import * as React from "react";
import { useParams } from "react-router-dom";
const withParams = (Component) => (props) => {
  const params = useParams();
  return /* @__PURE__ */ React.createElement(Component, { ...props, params });
};
export default withParams;
